// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Carrusel de tarjetas técnicas (Información personal + Router + ONT) ===== */
.resumen-tecnico-carousel {
  scrollbar-width: none; /* Firefox */
}

.resumen-tecnico-carousel::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}
`, "",{"version":3,"sources":["webpack://./src/pages/Clientes.css"],"names":[],"mappings":"AAAA,oFAAoF;AACpF;EACE,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa,EAAE,uBAAuB;AACxC","sourcesContent":["/* ===== Carrusel de tarjetas técnicas (Información personal + Router + ONT) ===== */\n.resumen-tecnico-carousel {\n  scrollbar-width: none; /* Firefox */\n}\n\n.resumen-tecnico-carousel::-webkit-scrollbar {\n  display: none; /* Chrome/Safari/Edge */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
